export default __webpack_public_path__ + "static/media/midasi_point_en_sp.4f6d1dc9.png";